export const POLICY_CHECK_ACCEPTED_EXTENSIONS = [".pdf", ".docx", ".doc"] as const;

export const POLICY_CHECK_FILE_ACCEPT =
  ".pdf,.docx,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document";

export const POLICY_CHECK_MAX_FILE_BYTES = 2 * 1024 * 1024;

export const isAcceptedPolicyCheckFile = (file: File): boolean => {
  const name = file.name.toLowerCase();
  return POLICY_CHECK_ACCEPTED_EXTENSIONS.some((ext) => name.endsWith(ext));
};

export const formatPolicyCheckFileSize = (bytes: number): string => {
  if (bytes < 1024) return `${bytes} Б`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} КБ`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} МБ`;
};
